// The athlete's exercise note (the pencil note). It is a fact of ONE workout:
// it lives on the item (`item.notes`) and a saved workout keeps it. There is
// no stored "current note" per exercise anywhere. A new workout only prefills
// it from saved history (the server sends those values at Start and with each
// picker row).
// `record.exerciseNotes` is this workout's local, never-synced draft memory:
// the prefilled values, then every edit made here, by exercise. It is what
// lets A -> B -> A bring A's draft back within the same workout. It never
// reaches the server on its own: only the notes of the items in the saved
// document become history.

function cleanNote(value) {
  return typeof value === "string" && value.length ? value : null;
}

export function normalizeExerciseNotes(notes) {
  if (!notes || typeof notes !== "object" || Array.isArray(notes)) return {};
  return Object.fromEntries(
    Object.entries(notes).map(([exerciseId, note]) => [exerciseId, cleanNote(note)])
  );
}

function knows(record, exerciseId) {
  return Boolean(exerciseId) &&
    Object.prototype.hasOwnProperty.call(record?.exerciseNotes || {}, exerciseId);
}

// The note an item for `exerciseId` starts with: what this workout already
// knows, else the value that came with the chosen exercise (a picker row).
export function personalNoteFor(record, exerciseId, fallback = null) {
  return knows(record, exerciseId)
    ? record.exerciseNotes[exerciseId]
    : cleanNote(fallback);
}

export function rememberExerciseNote(record, exerciseId, note) {
  if (!exerciseId) return record.exerciseNotes || {};
  return { ...(record.exerciseNotes || {}), [exerciseId]: cleanNote(note) };
}
